import { useEffect, useState } from "react";

const DARK_QUERY = "(prefers-color-scheme: dark)";

const isDarkNow = (): boolean => {
  const themeAttr = document.documentElement.dataset.theme;
  if (themeAttr === "dark") return true;
  if (themeAttr === "light") return false;
  return window.matchMedia(DARK_QUERY).matches;
};

// Returns true when the app is in dark mode — watches both the OS-level
// prefers-color-scheme media query and the explicit data-theme attribute
// toggle, so the chart option re-builds whenever either changes.
const useDarkMode = (): boolean => {
  const [isDark, setIsDark] = useState(isDarkNow);

  useEffect(() => {
    const mediaQuery = window.matchMedia(DARK_QUERY);
    const onMediaChange = () => setIsDark(isDarkNow());
    mediaQuery.addEventListener("change", onMediaChange);

    const observer = new MutationObserver(() => setIsDark(isDarkNow()));
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => {
      mediaQuery.removeEventListener("change", onMediaChange);
      observer.disconnect();
    };
  }, []);

  return isDark;
};

export default useDarkMode;
